/**
 * Copyright 2025 Phenix Real Time Solutions, Inc. Confidential and Proprietary. All Rights Reserved.
 */

import PropTypes from 'prop-types';
import styles from '../../../../../css/publisher.css';

const Select = ({defaultValue, onChange, disabled, options, placeholder}) => {
  return (
    <div className={styles.fullWidth}>
      <select
        defaultValue={defaultValue}
        onChange={(e) => onChange(e.target.value)}
        className={disabled ? `${styles.disabled} ${styles.customSelect}` : styles.customSelect}
        disabled={disabled}>
        {placeholder && (
          <option value="" disabled>
            {placeholder}
          </option>
        )}
        {options.map(option => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};

Select.propTypes = {
  defaultValue: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    label: PropTypes.string.isRequired
  })).isRequired,
  placeholder: PropTypes.string
};

export default Select;